import { useState } from 'react';
import { IColumnData, IRowData } from '@components/simple-table/types';
import moment from 'moment';
import { formatDate } from '@/lib/utils/date';
import { ItemTitle as ItemTitle } from '../components/table/item-title';
import { Action } from '../components/table/action';
import { useAppSelector } from '@/hooks/redux/redux';
import { isSaaS } from '@/lib/utils/access';
import { Box } from '@mantine/core';
import OverflowTip from '@components/OverflowTip';
import { useTranslation } from 'react-i18next';
import { ParentFilial } from '@/containers/pages/filials/components/table/item-title/ParentFilial';

export const useGetColumns = () => {
  const { t } = useTranslation();
  const { Settings } = useAppSelector((state) => state.userInfo);
  const columnsData: IColumnData[] = [
    {
      width: '300px',
      dataIndex: 'Title',
      title: t('servers.name'),
      hideColumn: false,
      render: (item: IRowData) => <ItemTitle item={item} />
    },
    {
      width: '120px',
      dataIndex: 'Shortname',
      title: t('filials.settings.filialCode'),
      hideColumn: false,
      render: (item: IRowData) => (
        <Box maw="200px">
          <OverflowTip size="sm">{item?.Company}</OverflowTip>
        </Box>
      )
    },
    {
      width: '246px',
      dataIndex: 'Company',
      title: t('filials.settings.filialParent'),
      hideColumn: false,
      render: (item: IRowData) => <ParentFilial item={item} />
    },
    {
      width: '146px',
      dataIndex: 'UsersCount',
      title: t('filials.diskSpace.table.users'),
      hideColumn: false,
      render: (item: IRowData) => item?.UsersCount
    },
    {
      width: '146px',
      dataIndex: 'Roles',
      title: t('profile.roles'),
      hideColumn: false,
      render: (item: IRowData) => item?.RolesCount
    },
    {
      width: '146px',
      dataIndex: 'DateOfCreate',
      title: t('dateOfCreation'),
      hideColumn: false,
      render: (item: IRowData) => formatDate(moment.utc(item?.DateOfCreate))
    },
    {
      width: '50px',
      dataIndex: 'Action',
      title: '',
      hideColumn: false,
      render: (item: IRowData) => <Action item={item} />
    }
  ].filter((item) => !isSaaS(Settings) || !['Shortname', 'Company'].includes(item.dataIndex));

  const [columns, setColumns] = useState<IColumnData[]>(columnsData);

  return { columns, setColumns };
};
